import styled from 'styled-components';

export const ActionItem = styled.div`
  margin-right: 40px;
`;

export const ActionLabel = styled.div`
  font-size: 12px;
  line-height: 20px;
  color: #748aa1;
  font-weight: 400;
  margin-bottom: 5px;
`;
